import { render, staticRenderFns } from "./MMemoryCookieStatusSummary.vue?vue&type=template&id=b5d12320&lang=pug&"
import script from "./MMemoryCookieStatusSummary.vue?vue&type=script&lang=ts&"
export * from "./MMemoryCookieStatusSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports